// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__HQtUG","validationTips":"StatementDescriptor_validationTips__2B-Cv"};